<template>
  <div class="faq-unit">
    <div
      class="faq-unit__title"
      :class="{ 'faq-unit__title--open': !collapsed }"
      @click="toggleCollapsible"
    >
      {{ title }}
      <div class="faq-unit__icon-wrapper">
        <span class="faq-unit__icon iconfont ifaq"></span>
      </div>
    </div>
    <transition
      name="faq-unit__transition"
      @enter="start"
      @afterEnter="end"
      @beforeLeave="start"
      @afterLeave="end"
    >
      <div v-if="!collapsed" class="faq-unit__text-box">
        <p class="faq-unit__text">
          <slot></slot>
        </p>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import type { RendererElement } from 'vue'
import { Mixpanel } from '@/analytics/mixpanel'

/**
 * @param title the title of the FAQ – will be clicked to expand its contents
 * @param type the type this FAQ item belongs to – used for mixpanel tracking
 */
const props = defineProps<{
  title: string
  type: string
}>()

const collapsed = ref(true)

function toggleCollapsible(): void {
  collapsed.value = !collapsed.value

  // Only track when FAQ item is expanded
  if (collapsed.value === false) {
    Mixpanel.trackFAQItemView(props.type, props.title)
  }
}

function start(el: RendererElement): void {
  el.style.height = '0px'
  el.style.height = el.scrollHeight + 'px'
}

function end(el: RendererElement): void {
  el.style.height = el.scrollHeight + 'px'
}
</script>

<style lang="scss" scoped>
.faq-unit {
  position: relative;

  &__transition {
    &-enter-active,
    &-leave-active {
      will-change: height, opacity;
      transition:
        height 0.3s ease-in-out,
        opacity 0.3s ease-in-out;
      overflow: hidden;
    }

    &-enter,
    &-leave-to {
      height: 0 !important;
      opacity: 0;
    }
  }
}
</style>
